import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { EDIT } from "const"
import { mtUsersRoute } from "client/parts/routes"
import {
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    Button,
} from "client/components"


const Form = () => {
    const user = useSelector((state: StoreType) => state.user.userView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${mtUsersRoute}/${EDIT}/${user.id}`

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={user.logo || Images.noAvatar} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.firstName}</Label>
                                <Input type="text" value={user.firstName} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.lastName}</Label>
                                <Input type="text" value={user.lastName} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.login}</Label>
                                <Input type="text" value={user.login} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.email}</Label>
                                <Input type="text" value={user.email} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.status}</Label>
                                <Input type="text" value={lang[user.status]} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                {lang.edit}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
